import axios from "axios";
import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { myHostname } from "../Utils.js";

const endpoint = "https://my.ezireturns.com";

export const useGetRequest = (path) => {

  const [status, setStatus] = useState("idle");
  const [data, setData] = useState([]);

  const auth = {
    headers: {
      'Authorization': myHostname()
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      setStatus("fetching");
      const res = await axios.get(`${endpoint}/${path}`, auth);
      if (res) {
        setData(res.data);
      }
      setStatus("fetched");
    };

    fetchData();
  }, [path]);

  return { status, data };
};

export const usePostRequest = (path, params) => {
  const [status, setStatus] = useState('idle');
  const [data, setData] = useState([]);

  const auth = {
    headers: {
      'Authorization': myHostname()
    },
  }; 

  const sendParams = {...params};

  useEffect(() => {
    const fetchData = async () => {
      setStatus('fetching');
      const res = await axios.post(`${endpoint}/${path}`, sendParams, auth);
      if (res) {
        setData(res.data);
      }
      setStatus('fetched');
    };

    fetchData();
  }, [path]);

  return {status, data};
};

export const sendPostRequest = async (path, params) => {

  const auth = {
    headers: {
      'Authorization': myHostname()
    },
  };

  const res = await axios.post(`${endpoint}/${path}`, params, auth);

  return res.data;
};

export const sendGetRequest = async (path) => {
  
  const auth = {
    headers: {
      'Authorization': myHostname()
    },
  };

  const res = await axios.get(`${endpoint}/${path}`, auth);

  return res.data;
};
